import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "파일 glob 사양",
  "description": "turbo에서 사용하는 파일 glob 사양에 대해 알아봅니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "파일 glob은 Turborepo 전반에 걸쳐 다양한 컨텍스트에서 포함하거나 제외할 파일을 구성하는 데 사용되며, turbo가 사용할 파일을 구체적으로 정의할 수 있습니다."
  }, {
    "heading": "glob-패턴",
    "content": "패턴"
  }, {
    "heading": "glob-패턴",
    "content": "설명"
  }, {
    "heading": "glob-패턴",
    "content": "*"
  }, {
    "heading": "glob-패턴",
    "content": "디렉토리의 모든 파일과 일치합니다"
  }, {
    "heading": "glob-패턴",
    "content": "**"
  }, {
    "heading": "glob-패턴",
    "content": "모든 파일과 하위 디렉토리를 재귀적으로 일치시킵니다"
  }, {
    "heading": "glob-패턴",
    "content": "some-dir/"
  }, {
    "heading": "glob-패턴",
    "content": "some-dir 디렉토리와 그 내용을 일치시킵니다"
  }, {
    "heading": "glob-패턴",
    "content": "some-dir"
  }, {
    "heading": "glob-패턴",
    "content": "some-dir이라는 이름의 파일 또는 some-dir 디렉토리와 그 내용을 일치시킵니다"
  }, {
    "heading": "glob-패턴",
    "content": "some-dir*"
  }, {
    "heading": "glob-패턴",
    "content": "some-dir로 시작하는 파일 및 디렉토리를 일치시키며, 디렉토리인 경우 내용도 포함합니다"
  }, {
    "heading": "glob-패턴",
    "content": "*.js"
  }, {
    "heading": "glob-패턴",
    "content": "디렉토리의 모든 .js 파일과 일치합니다"
  }, {
    "heading": "glob-패턴",
    "content": "!"
  }, {
    "heading": "glob-패턴",
    "content": "전체 glob을 부정합니다 (정의된 glob의 끝에 자동으로 /**를 적용합니다)"
  }, {
    "heading": "예제",
    "content": "패턴"
  }, {
    "heading": "예제",
    "content": "설명"
  }, {
    "heading": "예제",
    "content": "dist/**"
  }, {
    "heading": "예제",
    "content": "dist 디렉토리, 그 내용 및 모든 하위 디렉토리의 모든 파일과 일치합니다"
  }, {
    "heading": "예제",
    "content": "dist/"
  }, {
    "heading": "예제",
    "content": "dist 디렉토리와 그 내용을 일치시킵니다"
  }, {
    "heading": "예제",
    "content": "dist"
  }, {
    "heading": "예제",
    "content": "dist라는 이름의 파일 또는 dist 디렉토리, 그 내용 및 모든 하위 디렉토리를 일치시킵니다"
  }, {
    "heading": "예제",
    "content": "dist/some-dir/**"
  }, {
    "heading": "예제",
    "content": "현재 디렉토리의 dist/some-dir 디렉토리 및 모든 하위 디렉토리의 모든 파일과 일치합니다"
  }, {
    "heading": "예제",
    "content": "!dist"
  }, {
    "heading": "예제",
    "content": "dist 디렉토리와 모든 내용을 무시합니다"
  }, {
    "heading": "예제",
    "content": "dist*"
  }, {
    "heading": "예제",
    "content": "dist로 시작하는 파일 및 디렉토리와 일치합니다"
  }, {
    "heading": "예제",
    "content": "dist/*.js"
  }, {
    "heading": "예제",
    "content": "dist 디렉토리의 모든 .js 파일과 일치합니다"
  }, {
    "heading": "예제",
    "content": "!dist/*.js"
  }, {
    "heading": "예제",
    "content": "dist 디렉토리의 모든 .js 파일을 무시합니다"
  }, {
    "heading": "예제",
    "content": "dist/**/*.js"
  }, {
    "heading": "예제",
    "content": "dist 디렉토리와 그 하위 디렉토리의 모든 .js 파일을 재귀적으로 일치시킵니다"
  }, {
    "heading": "예제",
    "content": "../scripts/**"
  }, {
    "heading": "예제",
    "content": "한 디렉토리 위로, scripts 디렉토리의 모든 파일과 하위 디렉토리를 일치시킵니다"
  }],
  "headings": [{
    "id": "glob-패턴",
    "content": "Glob 패턴"
  }, {
    "id": "예제",
    "content": "예제"
  }]
};
export const toc = [{
  depth: 2,
  url: "#glob-패턴",
  title: _jsx(_Fragment, {
    children: "Glob 패턴"
  })
}, {
  depth: 2,
  url: "#예제",
  title: _jsx(_Fragment, {
    children: "예제"
  })
}];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h2: "h2",
    p: "p",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["파일 glob은 Turborepo 전반에 걸쳐 다양한 컨텍스트에서 포함하거나 제외할 파일을 구성하는 데 사용되며, ", _jsx(_components.code, {
        children: "turbo"
      }), "가 사용할 파일을 구체적으로 정의할 수 있습니다."]
    }), "\n", _jsx(_components.h2, {
      id: "glob-패턴",
      children: "Glob 패턴"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "패턴"
          }), _jsx(_components.th, {
            children: "설명"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "*"
            })
          }), _jsx(_components.td, {
            children: "디렉토리의 모든 파일과 일치합니다"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "**"
            })
          }), _jsx(_components.td, {
            children: "모든 파일과 하위 디렉토리를 재귀적으로 일치시킵니다"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "some-dir/"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "some-dir"
            }), " 디렉토리와 그 내용을 일치시킵니다"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "some-dir"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "some-dir"
            }), "이라는 이름의 파일 또는 ", _jsx(_components.code, {
              children: "some-dir"
            }), " 디렉토리와 그 내용을 일치시킵니다"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "some-dir*"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "some-dir"
            }), "로 시작하는 파일 및 디렉토리를 일치시키며, 디렉토리인 경우 내용도 포함합니다"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "*.js"
            })
          }), _jsxs(_components.td, {
            children: ["디렉토리의 모든 ", _jsx(_components.code, {
              children: ".js"
            }), " 파일과 일치합니다"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "!"
            })
          }), _jsxs(_components.td, {
            children: ["전체 glob을 부정합니다 (정의된 glob의 끝에 자동으로 ", _jsx(_components.code, {
              children: "/**"
            }), "를 적용합니다)"]
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "예제",
      children: "예제"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "패턴"
          }), _jsx(_components.th, {
            children: "설명"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dist/**"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "dist"
            }), " 디렉토리, 그 내용 및 모든 하위 디렉토리의 모든 파일과 일치합니다"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dist/"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "dist"
            }), " 디렉토리와 그 내용을 일치시킵니다"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dist"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "dist"
            }), "라는 이름의 파일 또는 ", _jsx(_components.code, {
              children: "dist"
            }), " 디렉토리, 그 내용 및 모든 하위 디렉토리를 일치시킵니다"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dist/some-dir/**"
            })
          }), _jsxs(_components.td, {
            children: ["현재 디렉토리의 ", _jsx(_components.code, {
              children: "dist/some-dir"
            }), " 디렉토리 및 모든 하위 디렉토리의 모든 파일과 일치합니다"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "!dist"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "dist"
            }), " 디렉토리와 모든 내용을 무시합니다"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dist*"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "dist"
            }), "로 시작하는 파일 및 디렉토리와 일치합니다"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dist/*.js"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "dist"
            }), " 디렉토리의 모든 ", _jsx(_components.code, {
              children: ".js"
            }), " 파일과 일치합니다"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "!dist/*.js"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "dist"
            }), " 디렉토리의 모든 ", _jsx(_components.code, {
              children: ".js"
            }), " 파일을 무시합니다"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dist/**/*.js"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "dist"
            }), " 디렉토리와 그 하위 디렉토리의 모든 ", _jsx(_components.code, {
              children: ".js"
            }), " 파일을 재귀적으로 일치시킵니다"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "../scripts/**"
            })
          }), _jsxs(_components.td, {
            children: ["한 디렉토리 위로, ", _jsx(_components.code, {
              children: "scripts"
            }), " 디렉토리의 모든 파일과 하위 디렉토리를 일치시킵니다"]
          })]
        })]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
